import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendLongFormBuilderDraft,
  BackendMutationDeleteLongFormBuilderDraftArgs,
} from 'src/types/backend';

import { FRAGMENT_LONG_FORM_BUILDER_DRAFT } from './schema';

const MUTATION = gql`
  mutation DeleteLongFormBuilderDraft($projectId: ID!, $draftId: ID!) {
    deleteLongFormBuilderDraft(projectId: $projectId, draftId: $draftId) {
      ...LongFormBuilderDraft
    }
  }
  ${FRAGMENT_LONG_FORM_BUILDER_DRAFT}
`;

type Variables = BackendMutationDeleteLongFormBuilderDraftArgs;
type Result = BackendLongFormBuilderDraft;

export const deleteLongFormBuilderDraft = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
